replacerStack